// @ts-nocheck

import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import useMergeProps from '../../../hooks/useMergeProps';
import theme from '../../../styled-components/dark';
import { KLVotesAgainstUserCounterIcon } from '../assets/img';
import KLCounter from '../components/common/KLCounter';
import selectKLVotesAgainstUserCounterProps from '../selectors/specifics/selectKLVotesAgainstUserCounterProps';

const StyledIcon = styled.img`
  position: absolute;
  width: 110%;
  left: -60%;
`;

const getColorFromCounter = (counter) => {
  if (counter === 5) {
    return theme.KLCounter.colorWarning;
  }
  if (counter > 5) {
    return theme.KLCounter.colorFatal;
  }
};

type KLVotesAgainstUserCounterContainerProps = {
  className?: string;
  roundIndex: number;
};

const KLVotesAgainstUserCounterContainer = ({ roundIndex, ...ownProps }: KLVotesAgainstUserCounterContainerProps) => {
  const selectorProps = useMemo(() => ({ roundIndex }), [roundIndex]);
  const selectedProps = useSelector((state) => selectKLVotesAgainstUserCounterProps(state, selectorProps));

  const Icon = useMemo(
    // eslint-disable-next-line react/display-name
    () => () => <StyledIcon src={KLVotesAgainstUserCounterIcon} alt="Number of votes against user" />,
    [],
  );

  const otherProps = useMemo(
    () => ({ Icon, color: getColorFromCounter(selectedProps.counter) }),
    [Icon, selectedProps],
  );

  const enhancedProps = useMergeProps({ ownProps, selectedProps, otherProps });

  return <KLCounter {...enhancedProps} />;
};

export default KLVotesAgainstUserCounterContainer;
